<!--选择excle文件并上传页面-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div>
          <div v-if="form_id" style="text-align: center;margin: 20px;font-size:22px;">往《{{form_name}}》里导入数据</div>
          <div v-else style="text-align: center;margin: 20px;font-size:22px;">手工发布查询</div>

<!--          <el-divider v-if="form_id">往《{{form_name}}》里导入数据</el-divider>
          <el-divider v-else>导入excel发布新查询</el-divider> -->
        </div>
        <div style="padding-left: 20px;font-size: 16px;">上传要导入的Excel文件.<span
            style="color: red;">如果上传失败，请将文件另存为“Microsoft excel 97-2003文件(*.xls)”文件后再上传。</span></div>
        <div style="padding: 10px;">
          <div style="padding: 10px;">
            <el-form ref="editForm" :model="editForm" size="mini">
              <div>
                <el-form-item>
                  <el-upload class="upload-demo" :http-request="uploadFile" action :on-preview="handlePreview"
                    :on-remove="handleRemove" :on-change="fileChange" :before-remove="beforeRemove" accept=".xls,.xlsx"
                    multiple :limit="1" :on-exceed="handleExceed" :file-list="fileList">
                    <div class="uploadFileStyle">
                      <el-tooltip class="item" effect="dark"
                        content="如果文件大小超过5M,可能传不上去。减小文件大小的方法是：新建一个excel文件,把旧文件中数据复制粘贴到新文件中保存,新文件会变小。可联系客服免费协助解决."
                        placement="top">
                        <el-button type="primary" plain>+点击上传Excel文件(Office 2007以上版本文件)</el-button>
                      </el-tooltip>

                      <div slot="tip" class="el-upload__tip" style="font-size: 18px;"></div>
                    </div>
                  </el-upload>
                  <div style="margin-top: 10px;" v-show="fileList.length>0">
                    <el-button type="primary" plain @click="emptyFileList">-删除文件</el-button>
                  </div>
                </el-form-item>
              </div>

              <el-form-item size="large">
                <!-- <el-button size="small" type="danger" @click="showUse">查看导入必读</el-button> -->
                <el-tooltip class="item" effect="dark"
                  content="请不要使用IE浏览器.其他浏览器如果点击无反应,把浏览器切换成'高速模式'后重新登录再试试.切换方法见下方帮助." placement="bottom">
                  <el-button size="small" type="primary" @click="uploadExcelFile">下一步</el-button>
                </el-tooltip>
              </el-form-item>

              <div>
                <el-button @click="howToSwitch" type="text" size="medium">
                  如何将浏览器切换成"高速模式"或"快速模式"
                </el-button>
              </div>

              <div style="margin-top: 10px;">
                <el-link type="danger"
                  href="javascript:window.open('http://wpa.qq.com/msgrd?v=3&uin=34424698&site=qq&menu=yes', '_brank')"
                  target="_blank">点我寻求客服QQ远程支持</el-link>
              </div>

              <!-- <div style="color:red;padding-top: 20px;">点下一步后长时间等待没有反应怎么办？<br>长时间没反应通常是excel文件过大造成的，请新建一个excel文件，把当前文件内容复制粘贴到新文件中即可，新的文件会变的小很多，把新文件上传即可。</div> -->
            </el-form>
          </div>

        </div>
      </el-col>
    </el-row>

    <el-dialog width="80%" :close-on-click-modal="false" title="如何切换浏览器的模式" :visible.sync="browserSwitchDialogVisible">
      <div class="colStyle">

        如下图所示找到红色框的部分，点击一下，切换到闪电图标上或者是"极速模式"或"高速模式"
        <br /><br />
        <img src="../assets/switch_browser.png" width="100%" />
        <br /><br />
        正确的应该是如下图所示：
        <br /><br />
        <img src="../assets/good_browser.png" width="100%" />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="browserSwitchDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

    <!--发放表格窗口-->
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="表格不能有合并的单元格" :visible.sync="checkFormDialogVisible">
      <el-form>
        <div>
          <div>
            为了方便核查数据，以及减少导入过程中出错的可能性，请将表格中合并单元格全部取消掉后再导入。
          </div>
          <div>取消所有合并单元格的方法是：选中单元格，点“合并单元”取消合并的单元格,取消后如果有空白单元格请填充好数据，方便后期确认数据。</div>
        </div>

      </el-form>
      <div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkFormDialogVisible=false">知道了</el-button>
      </div>
    </el-dialog>

    <!--导入必读-->
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="表格导入必读" :visible.sync="mustReadDialogVisible">
      <el-form>
        <div>
          <div>
            <div style="font-weight: bold;font-size: 16px;">问：适合导入什么样的表格？</div>
            <div>
              答：适合导入首行水平是表头，每行是填表人需要填写数据的表格；如果是复杂表格，请自行设计成首行是表头的表格后再导入。
            </div>
          </div>
          <div>
            <div style="font-weight: bold;font-size: 16px;margin-top: 10px;">问：在什么情况下使用导入表格功能？</div>
            <div>
              答：一种情况是您有表格，手机端制作录入麻烦，可以用导入；另外一种情况是需要填表人修改您excel表格里的数据，比如修订已有数据。
            </div>
          </div>

          <div>
            <div style="font-weight: bold;font-size: 16px;margin-top: 10px;">问：在什么情况导入空表？</div>
            <div>
              答：需要填表人填表时导入空表。
            </div>
          </div>

          <div>
            <div style="font-weight: bold;font-size: 16px;margin-top: 10px;">问：在什么情况导入数据？</div>
            <div>
              答：需要填表人修改您excel表格上的数据时导入数据。
            </div>
          </div>

          <div>
            <div style="font-weight: bold;font-size: 16px;margin-top: 10px;">问：表头特别复杂怎么导入？</div>
            <div>
              答：导入表格要观察列，因为一个列是一个数据，所以这个列叫什么就给这个列取什么名字。列名可以在预览界面点击单元格选择,可以减少输入量。
            </div>
          </div>

        </div>

      </el-form>
      <div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mustReadDialogVisible=false" type="primary">知道了</el-button>
      </div>
    </el-dialog>

    <el-dialog width="60%" :close-on-click-modal="false" title="上传Excel文件失败" :visible.sync="uploadFailDialogVisible">

      <div style="display: flex;justify-content: center;line-height: 2em;">
        上传文件失败！请检查Excel文件大小是否超过5M，如果Excel文件大小超过5M且表中的数据又不多，说明Excel文件中存在大量的空行或空列。修复方法是新建一个Excel文件，将原表格中的数据(只选数据，不是全选)粘贴到新Excel文件中保存后重新上传。如果仍然无法解决，请联系客服帮您处理。
      </div>

      <div style="margin-top: 20px;">
        客服微信：wx34424698 紧急电话：19909408114
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadFailDialogVisible=false">知道了</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        browserSwitchDialogVisible: false,
        fileList: [],
        courses: [],
        file: '',
        editForm: {
          id: '',
          exam: '',
          course: '',
          grade: '',
          paper_score: ''
        },

        checkFormDialogVisible: false,
        mustReadDialogVisible: false,

        form_id: '',
        form_name: '',

        uploadFailDialogVisible: false
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      // console.log('调用exam_list created')
      // this.loadCourses()
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

       // console.log('dddddddddddd',this.form_id,this.form_name)
    },
    methods: {
      handleRemove(file, fileList) {
        this.fileList = []
      },
      handlePreview(file) {},
      uploadFile(file) {
        // this.data.append('file', file.file)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`请先删除原来上传的文件后再上传!`)
        return true
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`)
      },
      uploadExcelFile() {
        if (this.fileList.length === 0) {
          this.$message.error('请上传excel文件！')
          return
        }

        let that = this

        let data = new FormData()
        data.set('username', this.username)

        let tmpExcelFile = this.fileList[0].raw

        // console.log(tmpExcelFile)

        data.append('file', tmpExcelFile)
        data.append('form_id', this.form_id)
        data.append('form_name', this.form_name)


        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/wansearch/web/_upload_data_excel_for_preview.jsp'
        this.axios.post(requestUrl, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          console.log('数据导入完成！！')

          if (res.data.result == '1') {
            // that.$message.success('成功')
            var uploaded_excel_file_name = res.data.excel_file
            that.$router.push({
                name: 'excel_data_preview_ex',
                params: {
                  username: that.username,
                  excel_file: uploaded_excel_file_name,
                  form_id:that.form_id,
                  form_name:that.form_name
                }
              })

              // .checkFormDialogVisible = true
            // that.$message.error('失败啦')
          }else{
            that.uploadFailDialogVisible = true
          }


          load.close()
        }).catch(err => {
          console.log('数据导入异常！！')
          console.log(err)
          load.close()

          that.uploadFailDialogVisible = true
        })
      },

      fileChange(file, fileList) {
        this.fileList = fileList
        console.log(fileList)
        return true
      },
      back() {
        this.$router.push('/validation_form_list')
      },
      emptyFileList() {
        this.fileList = []
      },
      howToSwitch() {
        this.browserSwitchDialogVisible = true
      },
      showUse() {
        this.mustReadDialogVisible = true
      }

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  .uploadFileStyle {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/import_data_excel_ex.vue